import type { SVGProps } from "react";
const SvgMenuBurger = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M389 97C389.552 97 390 97.4477 390 98C390 98.5523 389.552 99 389 99H371C370.448 99 370 98.5523 370 98C370 97.4477 370.448 97 371 97H389ZM389 91C389.552 91 390 91.4477 390 92C390 92.5523 389.552 93 389 93H371C370.448 93 370 92.5523 370 92C370 91.4477 370.448 91 371 91H389ZM389 85C389.552 85 390 85.4477 390 86C390 86.5523 389.552 87 389 87H371C370.448 87 370 86.5523 370 86C370 85.4477 370.448 85 371 85H389Z"
      fill="currentColor"
      transform="translate(-368 -80)"
    />
  </svg>
);
export default SvgMenuBurger;
